<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box invest-with-us">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<!-- <h1>Invest in business<br>funding with<br>American Credit®</h1> -->
              <h1>Invest in a worthy cause & proven business</h1>
							<br />
							<button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none;">Apply Now</button>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Try us now. See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="invest-with-us-main-img" src="../assets/imgs/American_Credit_Investors.png" alt="American Credit Investors"/>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%;">
			<div class="row platform-for-success">
				<div class="col-10 col-lg-8" style="background-color: #f6f9ff;"></div>
				<div class="col-2 col-lg-4" style="background-color: #00234d;"></div>
				<div class="container platform-for-success-content">
					<div class="row">
						<div class="col-12 col-lg-10 offset-lg-1">
							<h2 class="text-left">Unique opportunities from an underserved market</h2>
							<div class="row text-left">
								<div class="col-12 col-lg-6 pt-2">
									<div class="platform-for-success-card"> 
										<div class="image-container">
											<img src="../assets/imgs/unique_opportunity_1.png" alt="American Credit Invest Unique Opportunity 1">
										</div>
										<br>
                    <h4 class="platform-for-success-title">High tech may steal the headlines</h4>
                    <br>
										<p class="platform-for-success-text">But a recent government report shows small businesses are the single largest drivers of revenue and job growth in California<sup>1</sup>. Yet the state’s small businesses have poor access to the funds they need to grow, with banks unwilling to loan and other lenders charging unaffordable fees—challenges to which American Credit now offers a solution.</p>
										<br />
                  </div>
								</div> 
								<div class="col-12 col-lg-6 pt-2">
									<div class="platform-for-success-card"> 
										<div class="image-container">
											<img src="../assets/imgs/unique_opportunity_2.png" alt="American Credit Invest Unique Opportunity 2">
										</div>
										<br>
                    <h4 class="platform-for-success-title">Invest in powering America’s biggest economy</h4>
                    <br>
										<p class="platform-for-success-text">By first focusing its business lending within California, American Credit immediately addresses an underserved sector with $324 billion in market potential. We have combined deep financial data and risk expertise with partnerships including Experian, Plaid, Ocrolus and IBM to create a smarter, more efficient secured business lending platform.</p>
										<br />
										</div>
								</div>
							</div>
              <p class="platform-for-success-summary">See how we are providing better funding for California small and medium businesses. And find out how it offers opportunities for investors.</p>
              <button class="platform-for-success-button" @click="this.window.location.href='/contact-us'">Contact Us</button>
            </div>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%; background: white;">
      <div class="container platform how-works">
        <h2 class="text-center">Driving growth in business lending</h2>
        <p class="text-center invest-with-us-text how-works-p">American Credit opens new avenues for lending to businesses. Especially those who have passable, but less-than-prime, credit scores and to whom banks won’t loan. We combine local, personal service with advanced data science and financial expertise to assess risk quickly—and to accurately determine the success of a business and ability to repay.</p>
        <h2 class="text-center" style="padding-top: 0;">The result:</h2>
        <p class="text-center invest-with-us-text how-works-p">Fast funding on fair and transparent terms for businesses who need capital. Plus, new opportunities for investors. See how our business lending platform is set to drive growth in the huge and poorly-served business lending market. And discover how its integration of block chain technology, big data analytics and personal service deliver rigorous risk management. Find out more:</p>
        <div class="row how-works-button">
          <button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none; margin: 7px;">Apply Now</button>
          <button @click="this.window.open('https://youtu.be/JH96Q66Y4Hc','_blank')" style="background-color: #ffffff; color: rgb(84, 86, 255); font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: 1px solid rgb(84, 86, 255); margin: 7px;">Watch Demo</button>
        </div>
      </div>
    </div>

    <div style="width: 100%;">
      <div class="row user-feedback invest-with-us-user-feedback">
        <div class="col-2 col-lg-4" style="background-color: #00234d;"></div>
        <div class="col-10 col-lg-8" style="background-color: #f6f9ff;"></div>
        <div class="container row user-feedback-content">
          <div class="col-12 col-lg-5 offset-lg-1 user-feedback-content-left">
            <img src="../assets/imgs/American_Credit_Investor_Customer_Voice.png" alt="American Credit Investor Customer Voice"/>
          </div>
          <div class="col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right">
            <img src="../assets/imgs/quote.png" alt="American Credit Investor Customer Voice Quote">
            <p class="user-feedback-text invest-with-us-feedback">The loan officer could see how profitable we are. But even with three great years of business our bank won’t look beyond our credit score.</p>
            <p  class="user-feedback-name"><span style="color: #6d6d6d; font-weight: 300;">David Lee</span><br><span style="color: #3c3c3c; font-weight: 700;">Owner, Beautiful Smile Dental</span></p>
            <div class="user-feedback-button">
              <button @click="this.window.location.href='tel:1855-904-0188'">Let’s Talk</button>
              <p><span style="color: #3c3c3c; font-weight: 300;">Try us now. </span><span style="color: #3c3c3c; font-weight: 700;">See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform trust-us">
        <div class="row trust-us-box">
          <div class="col-12 col-lg-5 offset-lg-1 trust-us-inner-left">
            <div>
              <p class="trust-us-title">American Credit: the difference you can trust</p>
              <p class="trust-us-text" style="color: #686868; font-weight: 300;"><span style="font-weight: 700;">You work hard. We work hard. We share the same ethic.</span> That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.</p>
              <br />
              <div class="trust-us-button">
                <button @click="this.window.location.href='/get-start'">Apply Now</button>
                <p><span style="color: #3c3c3c; font-weight: 700;"><a href="contact-us">Feel free to contact us <i class="fa fa-long-arrow-right" style="color: #5456ff;"></i></a></span></p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 trust-us-inner-right">
            <img src="../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png" alt="American Credit Business loans the Difference You can Trust"/>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; background-color: white;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1">
            <div style="padding-top: 20px; font-family: Biotif; font-weight: 400; font-size: 14px;">
              Footnote
            </div>
            <div class="column">
              <ul style="margin: 0; padding-left: 15px;">
                <li style="list-style: decimal; font-family: Biotif; font-weight: 400; font-size: 14px;">California State Assembly, Small Business Leads California Economic Growth 2019</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";

export default {
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
 
  },
  mounted() {
    var seo = document.getElementById("seo")

    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }
    
    var keywords=document.getElementById("seokeywords");
    if(!keywords){
    keywords=document.createElement("meta");
    keywords.name="keywords";
    keywords.id="seokeywords"
    document.head.insertBefore(keywords,seo);
    }

    document.title="Invest in American Credit Today | American Credit"
    meta.content="Invest in a worthy cause & proven business. American Credit fights for business owners looking to acheive the American Dream: Accessible funding for all.";
    keywords.content="small business funding, investment opportunity, profitable, american credit";
  }
};
</script>

<style scoped lang="scss">
	@import "../assets/css/global.scss";
  @import "../assets/css/fonts.css";

  .invest-with-us {
    min-height: 680px !important;
    .business-loan-box-left-inner {
      margin-top: 160px !important;
    }
    .invest-with-us-main-img {
      width: 560px !important;
      margin-top: 60px !important;
    }
  }

  .platform-for-success {
		height: 1005px; 
		margin: 0; 
		padding: 0; 
		position: relative;
		.platform-for-success-content {
			position: absolute; 
			top: 90px; 
			left: calc(50vw - 720px);
			h2 {
				font-family: Biotif;
				color: #272727;
				font-size: 36px;
				font-weight: 700;
				margin-bottom: 60px;
				width: 550px;
			}
			.platform-for-success-card {
				border-radius: 10px; 
				box-shadow: 2px 4px 30px 0px rgba(236, 236, 236, 0.75); 
				height: 100%; 
				padding: 50px 50px 40px 50px; 
				background: white;
				.image-container {
					height: 63px;
					img {
						height: 100%; 
						width: auto; 
						object-fit: contain;
					}
        }
        .platform-for-success-title {
          font-family: Montserrat;
          color: #333333;
          font-size: 22px;
          font-weight: 600;
        }
				.platform-for-success-text {
          color: #808080;
          font-size: 17px;
          font-weight: 300;
          line-height: 28px;
				}
      }
      .platform-for-success-summary {
          color: #686868;
          font-size: 19px;
          font-weight: 300;
          line-height: 30px;
          margin-top: 72px;
          margin-bottom: 36px;
          width: 740px;
        }
        .platform-for-success-button {
          background-color: rgb(84, 86, 255); 
          color: #ffffff; 
          font-size: 16px; 
          font-weight: 700; 
          height: 50px; 
          width: 152px; 
          border-radius: 25px;
          border: none;
        }
		}
	}
  
  .invest-with-us-text {
    width: 866px !important;
  }
  .invest-with-us-user-feedback {
    height: 680px !important;
    // .invest-with-us-feedback {
    //   line-height: 36px;
    // }
  }

  @media (max-width:768px) {
    .invest-with-us {
      .business-loan-box-left-inner {
        margin-top: 40px !important;
      }
      .invest-with-us-main-img {
        width: 100% !important;
        margin-top: 0 !important;
        margin-bottom: 20px !important;
      }
    }

    .platform-for-success {
      height: 1600px; 
      .platform-for-success-content {
        left: 0;
        h2 {
          width: 80%;
        }
        .platform-for-success-summary {
          width: 80%;
        }
      }
    }

    .invest-with-us-text {
      width: auto !important;
    }

    .invest-with-us-user-feedback {
      height: 810px !important;
    }
  }
    
</style>


// WEBPACK FOOTER //
// invest.vue?11f5aa56